<template>
    <div>
        <div class="form-group">
            <label class="control-label">{{ trans('Location') }}</label>
            <select name="location" class="form-control" v-model="selectedLocation">
                <option v-for="item in locationItems" v-bind:key="item.id" v-bind:value="item.id">{{ item.name }}</option>
            </select>
        </div>
        <div v-if="selectedLocation === 'course'" class="form-group" v-bind:class="{ 'has-error' : error !== '' }">
            <label class="control-label">{{ trans('Products') }}</label>
            <select name="location_id" class="form-control" v-model="selectedLocationId">
                <option value="">{{ trans('Select a product') }}</option>
                <option v-for="item in products" v-bind:key="item.encoded_id" v-bind:value="item.encoded_id">{{ item.title }}</option>
            </select>
        </div>
        <div v-if="error !== ''" class="form-help">{{ error }}</div>
    </div>
</template>
<script>
import { EventBus } from '../../event-bus';

export default {
    props: {
        type: {
            type: String,
            required: true,
        },
        location: {
            type: String,
            required: true,
        },
        locationId: {
            type: String,
            require: false,
        },
        products: {
            type: Array,
            required: true,
        },
        locations: {
            type: Array,
            required: true,
        },
        error: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            locationItems: this.filterLocationsByType(this.type),
            selectedLocation: this.location,
            selectedLocationId: this.locationId,
        }
    },
    methods: {
        filterLocationsByType(type) {
            if (type === 'inline') {
                return this.locations.filter((location) => location.id !== 'sitewide');
            }

            return this.locations;
        },
        resetLocation() {
            if (this.locationItems.some((location) => location.id === this.selectedLocation)) {
                return;
            }

            this.selectedLocation = 'homepage';
            this.selectedLocationId = '';
            EventBus.$emit('field:location:selected', '');
            EventBus.$emit('field:location_id:selected', '');
        },
    },
    mounted() {
        EventBus.$on('field:type:selected', (type) => {
            this.locationItems = this.filterLocationsByType(type);
            this.resetLocation();
        });
    },
}
</script>